<template>
  <div class="upload-filelist">
    <div class="header">
      <div class="left">
        <div class="icon">
          <rt-icon name="rt-base-orders_fill" color="#fff" size="24" />
        </div>
        <div class="title">
          {{ title }}
        </div>
      </div>
      <el-upload
        ref="upload"
        :show-file-list="false"
        :on-success="handleSuccess"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
        :file-list="fileList"
        action
        class="right"
      >
        <rt-icon name="rt-base-upload" color="#fff" size="18" />
        <span>上传文件</span>
      </el-upload>
    </div>
    <div class="content">
      <el-table :data="list" stripe border>
        <el-table-column label="文件名称" sortable prop="name" width="300">
          <template slot-scope="scope">
            <!-- 进度条 -->
            <div
              v-if="
                uploadFlag == true &&
                  scope.row.uploadPercent > 0 &&
                  scope.row.uploadPercent != 100
              "
              class="progress-box"
            >
              <el-progress
                :percentage="scope.row.uploadPercent"
                :show-text="false"
              />
              <p class="progress">已上传{{ scope.row.uploadPercent }}%</p>
            </div>
            <!-- 非编辑状态 -->
            <div v-if="!scope.row.isEdit" class="noEdit">
              <rt-icon
                :name="iconName(scope.row.name)"
                :color="iconColor(scope.row.name)"
                size="21"
              />
              <span class="name">{{ scope.row.name }}</span>
            </div>
            <!-- 编辑状态 -->
            <div v-else class="cell-box">
              <el-input v-model="scope.row.name" placeholder="请填写文件名称" />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="文件大小" sortable prop="size" width="120">
          <template slot-scope="scope">
            <p v-if="scope.row.size > 0">{{ fileSize(scope.row.size) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="标题" sortable prop="title">
          <template slot-scope="scope">
            <p v-if="!scope.row.isEdit">{{ scope.row.title }}</p>
            <div v-else class="cell-box">
              <el-input
                v-model="scope.row.title"
                placeholder="请填写标题名称"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column label="备注" sortable prop="remark">
          <template slot-scope="scope">
            <p v-if="!scope.row.isEdit">{{ scope.row.remark }}</p>
            <div v-else class="cell-box">
              <el-input
                v-model="scope.row.remark"
                type="textarea"
                placeholder="请填写备注"
              />
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          sortable
          prop="operation"
          align="right"
          min-width="120"
        >
          <template slot-scope="scope">
            <div class="operation">
              <rt-list-button-group>
                <rt-button
                  v-if="!scope.row.isEdit"
                  text
                  type="plain"
                  @click="edit(scope)"
                >
                  编辑
                </rt-button>
                <rt-button v-else text type="plain" @click="save(scope)">
                  保存
                </rt-button>
                <rt-button text type="plain" @click="reupload(scope.$index)">
                  重新上传
                </rt-button>
                <rt-popconfirm
                  title="确定需要删除这条内容吗？"
                  @onConfirm="onConfirm(scope.row.name, scope.$index)"
                >
                  <rt-button slot="reference" text type="plain">
                    删除
                  </rt-button>
                </rt-popconfirm>
              </rt-list-button-group>
            </div>
          </template></el-table-column
        >
      </el-table>
    </div>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtListButtonGroup from '../business/list/rtListButtonGroup';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';

import ossClient from '../upload/aliyun.oss.client';
export default {
  name: 'RtUploadFilelist',
  components: {
    RtIcon,
    RtListButtonGroup,
    RtButton,
    RtPopconfirm
  },
  props: {
    uploadConf: {
      type: Object,
      required: true,
      default: () => {}
    },
    title: {
      type: String,
      default: '文件列表'
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      list: [],
      //是否显示进度条
      uploadFlag: false,
      uploadPercent: '',
      fileList: [],
      index: -1
    };
  },
  watch: {
    data(newValue) {
      this.$nextTick(() => {
        this.list = JSON.parse(JSON.stringify(newValue));
        this.list.map(item => {
          this.$set(item, 'isEdit', false);
        });
      });
    }
  },
  methods: {
    //上传前回调
    beforeUpload() {},
    //上传成功回调
    handleSuccess() {
      this.index = -1;
    },
    uploadFile(file) {
      let obj = {
        uploadPercent: 0,
        url: '',
        name: file.file.name,
        size: file.file.size,
        title: '',
        remark: '',
        isEdit: false
      };
      if (this.index >= 0) {
        this.list.splice(this.index, 1, obj);
      } else {
        this.list.push(obj);
      }
      console.log('file===', file);
      const that = this;
      let fileName = file.file.name;
      ossClient(this.uploadConf)
        .multipartUpload(fileName, file.file, {
          progress: function(p) {
            //p进度条的值
            that.uploadFlag = true;
            obj.uploadPercent = Math.floor(p * 100);
          }
        })
        .then(({ res, url, name }) => {
          if (res && res.status == 200) {
            this.uploadFlag = false;
            console.log(`阿里云OSS上传图片成功回调`, res, url, name);
            let response = `http://${this.uploadConf.bucket}.${this.uploadConf.region}.aliyuncs.com/${fileName}`;
            obj.url = response;
            obj.name = name;
            obj.title = name.substring(0, name.lastIndexOf('.'));
            this.index = -1;
          }
        })
        .catch(err => {
          this.uploadFlag = false;
          console.log(`阿里云OSS上传图片失败回调`, err);
        });
    },
    edit(scope) {
      scope.row.isEdit = true;
    },
    save(scope) {
      scope.row.isEdit = false;
    },
    reupload(index) {
      this.index = index;
      this.$refs.upload.$refs['upload-inner'].handleClick();
    },
    onConfirm(name, index) {
      this.del(name, index);
    },
    del(name, index) {
      ossClient(this.uploadConf)
        .delete(name)
        .then(res => {
          this.list.splice(index, 1);
          let arr = this.list.map(item => {
            let { isEdit, ...data } = item;
            return data;
          });
        })
        .catch(err => {
          console.log('删除失败', err);
        });
    },
    // 根据文件后缀名显示对应的icon
    iconName(name) {
      let fileName = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
      if (fileName === 'mp4') {
        return 'rt-base-file-video-fill';
      } else if (fileName === 'wps') {
        return 'rt-base-file-word-fill';
      } else if (fileName === 'ppt') {
        return 'rt-base-file-ppt-fill';
      } else {
        return 'rt-base-file-unknown-fill';
      }
    },
    // 根据文件后缀名显示对应的颜色值
    iconColor(name) {
      let fileName = name.substring(name.lastIndexOf('.') + 1).toLowerCase();
      if (fileName === 'mp4') {
        return '#55ceb3';
      } else if (fileName === 'wps') {
        return '#53a4fc';
      } else if (fileName === 'ppt') {
        return '#f7a959';
      } else {
        return '#f5f7fa';
      }
    },
    // 文件大小 —— 用文件大小 / 1024，如果小于1024，显示 M，如果大于1024，再 / 1024，显示 G
    // 用Math.round(size * 100) / 100 四舍五入保留2位小数
    fileSize(size) {
      // 这里的size是比特单位
      let sizeKB = size / 1024;
      if (sizeKB >= 1024) {
        if (sizeKB / 1024 > 1024) {
          return Math.round((sizeKB / 1024 / 1024) * 100) / 100 + 'G';
        } else {
          return Math.round((sizeKB / 1024) * 100) / 100 + 'M';
        }
      } else {
        return sizeKB + 'K';
      }
    }
  }
};
</script>

<style lang="less" scoped>
@deep: ~'>>>';
.upload-filelist {
  background-color: #fff;
  box-shadow: 0px 2px 4px 2px rgba(187, 194, 221, 0.3);
  .header {
    height: 60px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    .left {
      height: 32px;
      display: inline-flex;
      align-items: center;
      .icon {
        background-color: #53a4fc;
        padding: 4px;
        width: max-content;
        border-radius: 2px;
      }
      .title {
        color: #143e81;
        font-size: 16px;
        line-height: 21px;
        padding-left: 16px;
      }
    }
    .right {
      height: 32px;
      margin-left: auto;
      background-color: #1890ff;
      border-radius: 2px;
      padding: 0 12px;
      &:hover {
        background-color: #40a9ff;
      }
      &:active {
        background-color: #096dd9;
      }
      @{deep} {
        .el-upload {
          height: 100%;
          display: inline-flex;
          align-items: center;
          span {
            padding-left: 4px;
            color: #fff;
            font-size: 14px;
          }
        }
      }
    }
  }
  .content {
    @{deep} {
      .el-table {
        border: none;

        th,
        td {
          border: none;
        }

        &:before {
          height: 0;
        }

        .el-table__header-wrapper {
          th {
            border-bottom: none;
            height: 40px;
            line-height: 40px;
            padding: 0;
            background-color: #f0f3f7;

            position: relative;
            border-right: 1px solid transparent !important;

            &:first-child {
              padding-left: 14px;
            }

            &:not(:last-child) .cell::after {
              position: absolute;
              content: '';
              top: 5px;
              bottom: 5px;
              right: 0;
              width: 1px;
              background: #ced5ef;
            }
          }

          .cell {
            font-size: 14px;
            color: #6388c2;
            padding-left: 8px;
            padding-right: 8px;
          }
        }

        .sort-caret {
          border-width: 4px;
          left: 6px;
        }

        .sort-caret.ascending {
          border-bottom-color: #a9c2e8;
          top: 7px;

          &:hover {
            border-bottom-color: #6388c2;
          }
        }

        .sort-caret.descending {
          border-top-color: #a9c2e8;
          bottom: 9px;

          &:hover {
            border-top-color: #6388c2;
          }
        }

        .descending .sort-caret.descending {
          border-top-color: #1890ff;
        }

        .ascending .sort-caret.ascending {
          border-bottom-color: #1890ff;
        }

        .el-table__body-wrapper {
          .el-table__row {
            td {
              padding: 8px 0;
              height: 48px;
              line-height: 48px;
              .cell {
                color: #143e81;
                min-height: 24px;
                position: relative;
                display: flex;
                align-items: center;
                .cell-box {
                  width: 100%;
                }
                .progress-box {
                  position: absolute;
                  width: 90%;
                  z-index: 1;
                  background-color: rgba(255, 255, 255, 0.8);
                  .progress {
                    margin-top: 8px;
                    font-size: 12px;
                    line-height: 16px;
                  }
                }
                .noEdit {
                  display: flex;
                }
                span.name {
                  padding-left: 8px;
                }
                .el-input__inner {
                  color: #143e81;
                  height: 32px;
                  line-height: 32px;
                  padding: 0 8px;
                }
                .el-textarea__inner {
                  color: #143e81;
                  padding: 5px 8px;
                  height: max-content;
                  font-family: 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
                }
              }
            }

            td:first-child {
              padding-left: 14px;
            }

            td:last-child {
              .cell {
                float: right;
                padding: unset;
                padding-right: 14px;
              }
            }
          }

          .el-table__row--striped {
            td {
              background: #f7f9fc;
            }
          }
        }
      }
    }

    .operation {
      .rt-list-button-group {
        height: 24px;
      }
      .rt-button {
        background-color: red;
        min-width: unset;
        padding: 0 10px;

        &:not(:last-child) {
          border-radius: unset;
          border-right: 1px solid #e8ecfc;
        }

        &:hover {
          border-color: #e8ecfc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// rtUploadFilelist.vue?786c3c60